module.exports = __webpack_public_path__ + "static/media/second_circle.61ab18a7.png";